import { Link, List, ListItem, Typography, makeStyles } from "@material-ui/core";
import * as React from "react";
import ReactMarkdown, { Components } from "react-markdown";

const useStyles = makeStyles(() => ({
  h1: {
    fontSize: 16,
    fontWeight: 700,
    margin: "16px 0 8px",
    "&:first-child": {
      marginTop: 0,
    },
  },
  h2: {
    fontSize: 15,
    fontWeight: 700,
    margin: "16px 0 8px",
    "&:first-child": {
      marginTop: 0,
    },
  },
  h3: {
    fontSize: 14,
    fontWeight: 700,
    margin: "12px 0 4px",
    "&:first-child": {
      marginTop: 0,
    },
  },
  p: {
    fontSize: 14,
    lineHeight: 1.7,
    margin: "0 0 8px",
  },
  list: {
    paddingLeft: 20,
    margin: "0 0 8px",
  },
  listItem: {
    display: "list-item",
    padding: 0,
    fontSize: 14,
    lineHeight: 1.7,
  },
  link: {
    overflowWrap: "anywhere",
    wordBreak: "break-word",
  },
}));

interface MarkdownTextViewerProps {
  children: string;
}

// 同意モーダル等の本文表示に使う md レンダラー。react-markdown をこのファイルに集約し、
// 見出し・段落・リストを本文ボックス向けの控えめな字級・余白に寄せる。raw HTML は描画しない（既定挙動）
export const MarkdownTextViewer: React.FC<MarkdownTextViewerProps> = ({ children }) => {
  const classes = useStyles();

  const components: Components = {
    h1: ({ children: c }) => <Typography className={classes.h1}>{c}</Typography>,
    h2: ({ children: c }) => <Typography className={classes.h2}>{c}</Typography>,
    h3: ({ children: c }) => <Typography className={classes.h3}>{c}</Typography>,
    p: ({ children: c }) => <Typography className={classes.p}>{c}</Typography>,
    ul: ({ children: c }) => (
      <List className={classes.list} dense disablePadding component="ul" style={{ listStyleType: "disc" }}>
        {c}
      </List>
    ),
    ol: ({ children: c }) => (
      <List className={classes.list} dense disablePadding component="ol" style={{ listStyleType: "decimal" }}>
        {c}
      </List>
    ),
    li: ({ children: c }) => <ListItem className={classes.listItem}>{c}</ListItem>,
    a: ({ children: c, href }) => (
      <Link className={classes.link} href={href} target="_blank" rel="noopener noreferrer">
        {c}
      </Link>
    ),
  };

  return <ReactMarkdown components={components}>{children}</ReactMarkdown>;
};
